import { styled } from '../jss-style';
import dividerStyle from './divider';

const useDividerStyle = styled(dividerStyle, 'divider');
export { dividerStyle, useDividerStyle };
export default useDividerStyle;
